import OpenAI from 'openai';

export class EmbeddingService {
  private openai: OpenAI;
  private model: string = 'text-embedding-3-small';
  
  constructor() {
    const apiKey = import.meta.env.VITE_OPENAI_API_KEY;
    if (!apiKey) {
      throw new Error('OpenAI API key not configured. Please set VITE_OPENAI_API_KEY or implement backend API.');
    }
    
    this.openai = new OpenAI({
      apiKey,
      dangerouslyAllowBrowser: true // TODO: Move to backend for production security
    });
  }

  async createEmbedding(text: string): Promise<number[]> {
    const response = await this.openai.embeddings.create({
      model: this.model,
      input: text,
    });
    
    return response.data[0].embedding;
  }

  async createEmbeddings(texts: string[]): Promise<number[][]> {
    const response = await this.openai.embeddings.create({
      model: this.model,
      input: texts,
    });
    
    return response.data.map(item => item.embedding);
  }

  getModelDimensions(): number {
    // text-embedding-3-small has 1536 dimensions
    return 1536;
  }
}

let _embeddingService: EmbeddingService | null = null;

export const embeddingService = {
  get instance(): EmbeddingService {
    if (!_embeddingService) {
      _embeddingService = new EmbeddingService();
    }
    return _embeddingService;
  },
  
  // Proxy methods for backward compatibility
  async createEmbedding(text: string): Promise<number[]> {
    return this.instance.createEmbedding(text);
  },
  
  getModelDimensions(): number {
    return this.instance.getModelDimensions();
  }
};